module.exports = __webpack_public_path__ + "static/12.2_classical_greece-48fc2ba9e0198aa44b300618fc0f6105.pdf";